import { SecureStorage, KeychainAccess } from "@aparajita/capacitor-secure-storage";
import { Preferences } from "@capacitor/preferences";
import { createNativeSession } from "./native-session.ts";

const sessionKey = "session";
const loginKey = "login";
const installationKey = "edubgt_secure_installation";

export const nativeSession = createNativeSession({
  async get() {
    const value = await SecureStorage.get(sessionKey, false, false);
    return typeof value === "string" ? value : null;
  },
  set: (value) => SecureStorage.set(sessionKey, value, false, false, KeychainAccess.whenUnlockedThisDeviceOnly),
  async remove() { await SecureStorage.remove(sessionKey, false); },
});

export async function initializeSecureStorage() {
  await SecureStorage.setKeyPrefix("edubgt_");
  await SecureStorage.setSynchronize(false);
  await SecureStorage.setDefaultKeychainAccess(KeychainAccess.whenUnlockedThisDeviceOnly);
  if (!(await Preferences.get({ key: installationKey })).value) {
    // Keychain can survive uninstall. A fresh installation must authenticate again.
    await SecureStorage.remove(sessionKey, false);
    await SecureStorage.remove(loginKey, false);
    await Preferences.set({ key: installationKey, value: "1" });
  }
  // Retire plaintext credentials from pre-release builds, without restoring them.
  await Preferences.remove({ key: "edubgt_native_session" });
  await Preferences.remove({ key: "edubgt_native_login_verifier" });
  await nativeSession.restore();
}

export async function storeNativeLogin(verifier: string, callbackQuery: string) {
  await SecureStorage.set(loginKey, { verifier, callbackQuery, createdAt: Date.now() }, false, false, KeychainAccess.whenUnlockedThisDeviceOnly);
}

export async function readNativeLogin() {
  const value = await SecureStorage.get(loginKey, false, false);
  if (!value || typeof value !== "object" || !("verifier" in value) || !("createdAt" in value)
    || typeof value.verifier !== "string" || typeof value.createdAt !== "number"
    || Date.now() - value.createdAt > 10 * 60_000 || value.createdAt > Date.now()) {
    await clearNativeLogin();
    return null;
  }
  return { verifier: value.verifier, callbackQuery: "callbackQuery" in value && typeof value.callbackQuery === "string" ? value.callbackQuery : "" };
}

export async function clearNativeLogin() { await SecureStorage.remove(loginKey, false); }
